if (!customElements.get('quick-atc-option')) {
    customElements.define(
      'quick-atc-option',
      class quickAtcOption extends HTMLElement {

          constructor() {
              super(); 
              this.selectors = {
                              gridContainer: '[js-product-grid-card-wrapper]',
                              gridProductData: '[js-product-grid-product-data]',
                              variantOption: '[js-product-option-quick-atc]'
                          }
              this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
              
              
              this.addEventListener('click', function(e) {
                  const selectedOption = e.target.closest(this.selectors.variantOption)?.dataset.optionValue;
                  const productCard = e.target.closest("[js-product-grid-card-wrapper]");
                  const atcBtn = productCard.querySelector("[js-atc-btn]");
                  const atcBtnLabel = atcBtn.querySelector("[js-atc-btn-label]");
                  productCard.querySelectorAll("quick-atc-option").forEach( option => option.classList.remove('active'));
                  e.currentTarget.classList.add('active');
                  let selectedVariantId;

                  const container = this.closest(this.selectors.gridContainer)
                  const productData = container.querySelector(this.selectors.gridProductData)
                  
                  const product = JSON.parse(productData.innerText)
                  const variants = product.variants || product;
                  
                  variants.map(variant => {
                    if(variant.title == selectedOption) selectedVariantId = variant.id
                  });
                 
                  atcBtn.setAttribute("data-variant-id", selectedVariantId);
                  if(e.currentTarget.classList.contains("soldout")) {
                    atcBtn.classList.add("disabled");
                    atcBtnLabel.innerText = 'sold out';
                  }else {
                    atcBtn.classList.remove("disabled");
                    atcBtnLabel.innerText = 'add to cart';
                  }
                
              })

            this.initAllOptions();
        }

        initAllOptions() {
          const container = document.querySelectorAll(this.selectors.gridContainer)
          container.forEach(gridItem => {
            const productData = JSON.parse(gridItem.querySelector(this.selectors.gridProductData).innerHTML)
            const variants = productData.variants || productData;
            const allOptions =  gridItem.querySelectorAll(this.selectors.variantOption)

            allOptions.forEach(option => {
              const optionValue = option.dataset?.optionValue 
              variants.forEach(variant => {
                if(variant.title == optionValue && !variant.available) {
                  option.classList.add('soldout')
                }
              })
            });
            
            let firstAvailableOption = gridItem.querySelector(".quick_atc_product_value");

            //========= New
            if(gridItem.querySelector(".quick_atc_product_value:not(.soldout)") != null) {
              firstAvailableOption = gridItem.querySelector(".quick_atc_product_value:not(.soldout)");
            }
           
            firstAvailableOption?.classList.add("active");

          })
        }
        
        connectedCallback() {

        }
        handleErrorMessage(errorMessage = false) {
          console.log(errorMessage.message, errorMessage.description)
          let errorMsg=  errorMessage.message + ' : ' + errorMessage.description
          alert(errorMsg)
        }
      }
    );
  };

function initAtcBtns() {
  const atcBtns = document.querySelectorAll("[js-atc-btn]:not(.initialized)");

  if(!atcBtns) return;
  atcBtns.forEach( btn => {
    btn.classList.add("initialized");
    btn.addEventListener("click", ajaxAddToCart)
  });

  function ajaxAddToCart(evt) {
    evt.preventDefault();
    const variantId = parseInt(this.getAttribute("data-variant-id"));
    this.classList.add("loading");
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    // Grab any hidden inputs for properties
    this.closest("[js-product-grid-card-wrapper]")?.querySelectorAll('input[name^="properties["]')?.forEach(input => {
      formData.append(input.name, input.value);
    });
    
    if (this.cart) {
      formData.append(
        'sections',
        this.cart?.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      this.cart?.setActiveElement(document.activeElement);
    }
    config.body = formData;

    this.cart?.setActiveElement(document.activeElement);


    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'quick-atc-option',
          productVariantId: variantId,
          cartData: response,
        });
        if(response.status) {
          this.nextElementSibling.innerText = response.description;
          this.nextElementSibling.classList.remove('hidden');
          this.classList.remove("loading");
          setTimeout(() => {
            this.nextElementSibling.innerText = '';
            this.nextElementSibling.classList.add('hidden');
          }, 3000)
        } else {
          this.classList.remove("loading");
          window.MicroBus.emit("cart:added", {});
        }
        
      })
      .catch((e) => {
        console.log("Error : ", e)
      })
  }
}

initAtcBtns();
document.addEventListener("quick-atc-btn:init", initAtcBtns);
  

